/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientSearchAdviserLinkResponseDto = {
    /**
     * Adviser link ID
     */
    id: string;
    /**
     * Type of adviser link
     */
    linkType: ClientSearchAdviserLinkResponseDto.linkType;
    /**
     * Adviser link status
     */
    status: ClientSearchAdviserLinkResponseDto.status;
    /**
     * Adviser user ID for navigation to adviser detail
     */
    adviserUserId?: string | null;
    /**
     * Adviser display name
     */
    adviserName: string;
};
export namespace ClientSearchAdviserLinkResponseDto {
    /**
     * Type of adviser link
     */
    export enum linkType {
        AUTHORISED_REP = 'AUTHORISED_REP',
        SERVICING_ADVISER = 'SERVICING_ADVISER',
    }
    /**
     * Adviser link status
     */
    export enum status {
        CURRENT = 'CURRENT',
        HISTORICAL = 'HISTORICAL',
    }
}

